import React from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ArticleIcon from '@mui/icons-material/Article';

const Protocol = () => {
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    return (
        <>
            <div style={{ width: '80%', display: 'flex', margin:'auto', marginTop:'2rem', marginBottom:'1rem'}}>
                <ArticleIcon style={{ color: '#10609e' }}/>
                <p style={{ width: '80%', marginTop: '3px', marginLeft:'1rem', fontWeight:'bold', color:'#10609e'  }}>Sunrise study protocol</p><br />
            </div>
            <Accordion className='accordian_members' expanded={expanded === 'panel3'} onChange={handleChange('panel3')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3bh-content"
                    id="panel3bh-header"
                >
                    <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0 }}>
                        What measurements are made for each child in the SUNRISE Study?
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        <ul style={{ marginLeft: '2rem' }}>
                            <li>Height and weight using stadiometer/scales</li>
                            <li>Accelerometry using a hip-worn ActiGraph</li>
                            <li>Executive functions using the Early Years Toolbox apps– Go/No-Go and Mr Ant (EYToolbox)</li>
                            <li>Fine and Gross Motor Skills (NIH Toolbox):</li>
                            <ul style={{ marginLeft: '2rem', listStyleType: 'circle' }}>
                                <li data-text="Manipulation: ">9-hole peg-board test</li>
                                <li data-text="Mobility and posture: ">Supine-Timed up and go (S-TUG)</li>
                                <li data-text="Posture: ">One-leg standing balance test</li>
                                <li data-text="Lower body strength and mobility: ">Standing long jump</li>
                                <li data-text="Upper body strength: ">hand grip dynamometer</li>
                            </ul>
                            <li>Parent Questionnaire – reporting their child’s use of electronic media, sleep quality, restrained sedentary time,
                                potential correlates of time spent outdoors and of sleep, food habits and eating behaviours.</li>
                        </ul>
                    </Typography>
                </AccordionDetails>
            </Accordion >
            <Accordion className='accordian_members' expanded={expanded === 'panel4'} onChange={handleChange('panel4')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0 }}>Are there any other measures?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography >
                        <ul style={{ listStyleType: 'none' }}>
                            <li>Yes, SUNRISE also asks countries to conduct the ‘Early Childhood Education and Care services’ or “centre questionnaire”
                                following data collection within each participating Early Childhood Education and Care Centre. This questionnaire reports
                                on consent response rates, factors associated with outdoor play, naptime and food consumed within the services, and outdoor
                                air quality during data collection.</li><br />
                            <li>For the Pilot Study, Focus groups are conducted in at least one urban and one rural area with parents and educators.</li><br />
                            <li>For the Pilot Study, we are also asking countries to ask 10 parents (preferably 5 urban and 5 rural) to complete the parent questionnaire a second time 14 days after the first was completed.</li>
                        </ul>
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion className='accordian_members' expanded={expanded === 'panel18'} onChange={handleChange('panel18')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0 }}>Can we add additional questions or measurements to those in the SUNRISE protocol during our data collection?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography >
                        Any additional measurements can affect the feasibility of the study as children/parents may not complete all SUNRISE measures. Any additional measurements must
                        be approved by the SUNRISE Coordinating Centre and the SUNRISE Leadership Group.
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion className='accordian_members' expanded={expanded === 'panel22'} onChange={handleChange('panel22')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0 }}>How long does each child need to wear the accelerometer for?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography >
                        The child needs to wear the accelerometer for a minimum of 5 days continuously (including during sleep and nap time). Please note that the accelerometer is
                        not waterproof, so it should be removed when the child is swimming, bathing, or showering. Once these activities are complete, the accelerometer should be
                        promptly put back on the child.
                    </Typography>
                </AccordionDetails>
            </Accordion>
        </>
    )
}

export default Protocol
